<template>
  <v-row dense class="justify-center align-center">
    <v-col :cols="autorecognitionTrackerSettings ? '12' : '4'" @click="navigateToAIPage()">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-hover v-slot="{ hover }">
              <MiniStatistic
                :elevation="hover ? 4 : 2"
                :class="hover ? 'pointer' : ''"
                icon=" mdi-file-check-outline"
                :title="documentsRecognizedCount.toString()"
                :color="autorecognitionTrackerSettings ? autorecognitionTrackerSettings.recognizedColor : 'light-green darken-3'"
                :iconSize="autorecognitionTrackerSettings ? '48' : '18'"
                :pading="autorecognitionTrackerSettings ? 'py-3' : 'py-0'"
                :fontSize="autorecognitionTrackerSettings ? '25' : '13'"
                :textColor="autorecognitionTrackerSettings ? autorecognitionTrackerSettings.recognizedTextColor : '#FAFAFA'"
              />
            </v-hover>
          </div>
        </template>
        <span>{{ $t("ValidatedDocuments") }}</span>
      </v-tooltip>
    </v-col>
    <v-col :cols="autorecognitionTrackerSettings ? '12' : '4'" @click="navigateToAIPage()">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-hover v-slot="{ hover }">
              <MiniStatistic
                :elevation="hover ? 4 : 2"
                :class="hover ? 'pointer' : ''"
                icon="mdi-file-document"
                :title="documentsPendingReviewCount.toString()"
                :color="autorecognitionTrackerSettings ? autorecognitionTrackerSettings.pendingColor : 'amber darken-1'"
                :textColor="autorecognitionTrackerSettings ? autorecognitionTrackerSettings.pendingTextColor : '#FAFAFA'"
                :iconSize="autorecognitionTrackerSettings ? '48' : '18'"
                :pading="autorecognitionTrackerSettings ? 'py-3' : 'py-0'"
                :fontSize="autorecognitionTrackerSettings ? '25' : '13'"
              />
            </v-hover>
          </div>
        </template>
        <span>{{ $t("DocumentsPendingReview") }}</span>
      </v-tooltip>
    </v-col>
    <v-col :cols="autorecognitionTrackerSettings ? '12' : '4'" @click="navigateToAIPage()">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-hover v-slot="{ hover }">
              <MiniStatistic
                :elevation="hover ? 4 : 2"
                :class="hover ? 'pointer' : ''"
                icon="mdi-text-box-remove-outline"
                :title="documentsFailedCount.toString()"
                :color="autorecognitionTrackerSettings ? autorecognitionTrackerSettings.errorColor : 'red accent-4'"
                :textColor="autorecognitionTrackerSettings ? autorecognitionTrackerSettings.errorTextColor : '#FAFAFA'"
                :iconSize="autorecognitionTrackerSettings ? '48' : '18'"
                :pading="autorecognitionTrackerSettings ? 'py-3' : 'py-0'"
                :fontSize="autorecognitionTrackerSettings ? '25' : '13'"
              />
            </v-hover>
          </div>
        </template>
        <span>{{ $t("DocumentsFailed") }}</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>
<script>
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import DocumentIntelligenceProvidersService from "@/services/DocumentIntelligenceProvidersService";
import RecognitionStatus from "@/ecm/variables/RecognitionStatus";

export default {
  props: {
    autorecognitionTrackerSettings: {
      type: Object,
      default: null,
    },
    refresh: {
      type: Number,
      default: 0
    }
  },
  components: {
    MiniStatistic,
  },
  data() {
    return {
      documentsPendingReviewCount: 0,
      documentsFailedCount: 0,
      documentsRecognizedCount: 0,
      hover: false,
    };
  },
  methods: {
    navigateToAIPage() {
      if (this.$route.path != "/aiRecognition/documents" || this.autorecognitionTrackerSettings != null){
        this.$router.push({ path: "/aiRecognition/documents" });
      }
    }
  },
  watch: {
    refresh(newVal, oldVal) {
      if (newVal !== oldVal) {
        DocumentIntelligenceProvidersService.getDocumentsCountForEachStatus().then(
        (response) => {
          let recognizedStatus = response.StatusCounts.find(x => x.Status === RecognitionStatus.Validated);
          this.documentsRecognizedCount = recognizedStatus ? recognizedStatus.Count : 0;

          let failedStatus = response.StatusCounts.find(x => x.Status === RecognitionStatus.Failed);
          this.documentsFailedCount = failedStatus ? failedStatus.Count : 0;

          let pendingReviewStatus = response.StatusCounts.find(x => x.Status === RecognitionStatus.PendingReview);
          this.documentsPendingReviewCount = pendingReviewStatus ? pendingReviewStatus.Count : 0;
        }
      );
      }
    }
  }
};
</script>
